import type { Saturation } from '../../../../business/highDemand';

export function useMergeSuperWithHigh(variant: Saturation) {
  return variant === 'superHigh' ? 'high' : variant;
}
